import { columnsList } from '@op/pages/SteamPerformance/utils';
import { DownloadConfigInfoType } from '../types';

export const SteamInsightGameDurationTable: DownloadConfigInfoType = {
  columns: () => {
    return columnsList.map(({ key, header, format, numFmt, downloadKey }) => {
      return {
        key: downloadKey || key,
        header,
        renderHelper: [
          (item: { [x: string]: any }, key: string | number) => {
            const value: any = item[key];
            if (key === 'key') return format?.(value);

            return value;
          },
        ],
        numFmt,
      };
    });
  },
};
